import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Rows: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', ry: '2' }],
    ['line', { x1: '3', x2: '21', y1: '12', y2: '12' }],
  ],
];

export default Rows;
